<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-09 23:12:00
 * @LastEditTime: 2025-09-28 23:14:44
-->
<template>
    <div class="tool">
      <div class="title-block">
        <van-button type="info" block @click="handleTips" icon="description-o">智能筛选条件查看</van-button>
      </div>
      <main style="margin-top: 66px;">
        <listPost type="precisePost"></listPost>
      </main>

      <van-tabbar v-model="active">
        <van-tabbar-item icon="orders-o" @click="toUrl('/servicePost')">岗位筛选</van-tabbar-item
        >
        <van-tabbar-item icon="apps-o"
          >智能匹配</van-tabbar-item
        >
        <van-tabbar-item icon="manager-o" @click="toUrl('/servicePostMyCollect')"
          >我的收藏</van-tabbar-item
        >
      </van-tabbar>


      <van-dialog 
        v-model="showDialog" 
        title="报考信息查看" 
        show-cancel-button 
        cancel-button-text="确定"
        cancel-button-color="blue"
        confirm-button-text="信息有误，重新填写"
        confirm-button-color="red"
        @confirm="handleConfirm"
      >
        <div class="box-wrapper">
          <ul>
            <li>
              <span>姓名：</span>
              <span>{{ currentStudentData.realName ? currentStudentData.realName : '无' }}</span>
            </li>
            <li>
              <span>性别：</span>
              <span>{{ currentStudentData.sex ? currentStudentData.sex : '无' }}</span>
            </li>
            <li>
              <span>最高学历：</span>
              <span>{{ currentStudentData.educationBackground ? currentStudentData.educationBackground : '无' }}</span>
            </li>
            <li>
              <span>学位：</span>
              <span>{{ currentStudentData.studentDegree ? currentStudentData.studentDegree : '无' }}</span>
            </li>
            <li>
              <span>专业：</span>
              <span>{{ currentStudentData.majorSelect ? currentStudentData.majorSelect : '无' }}</span>
            </li>
            <li>
              <span>专业(手输)：</span>
              <span>{{ currentStudentData.major ? currentStudentData.major : '无' }}</span>
            </li>
            <li>
              <span>是否985：</span>
              <span>{{ currentStudentData.isNine ? currentStudentData.isNine : '无' }}</span>
            </li>
            <li>
              <span>是否211：</span>
              <span>{{ currentStudentData.isTwo ? currentStudentData.isTwo : '无' }}</span>
            </li>
            <li>
              <span>是否双一流：</span>
              <span>{{ currentStudentData.isFirst ? currentStudentData.isFirst : '无' }}</span>
            </li>
            <li>
              <span>是否党员：</span>
              <span>{{ currentStudentData.partyMember ? currentStudentData.partyMember : '无' }}</span>
            </li>
            <li>
              <span>是否退役：</span>
              <span>{{ currentStudentData.retirement ? currentStudentData.retirement : '无' }}</span>
            </li>
            <li>
              <span>是否军人配偶：</span>
              <span>{{ currentStudentData.isArmyMate ? currentStudentData.isArmyMate : '无' }}</span>
            </li>
            <li>
              <span>身份属性：</span>
              <span>{{ currentStudentData.idAttributes ? currentStudentData.idAttributes : '无' }}</span>
            </li>
            <li>
              <span>户籍所在地：</span>
              <span>{{ currentStudentData.address ? currentStudentData.address : '无' }}</span>
            </li>
            <li>
              <span>报考意向地区：</span>
              <span>{{ currentStudentData.intentionArea ? currentStudentData.intentionArea : '无' }}</span>
            </li>
          </ul>
        </div>
      </van-dialog>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import listPost from "@/views/servicePost/component/listPost.vue"
  import { Image as VanImage } from 'vant'
  import axios from 'axios'
  Vue.use(VanImage)
  import { Tabbar, TabbarItem, Dialog } from 'vant'
  Vue.use(Tabbar)
  Vue.use(TabbarItem)
  Vue.use(Dialog)
  import { Toast } from 'vant'
  import { companyList, getDictType, postFullInfo, postGetLinkCode } from '@/api/xicaiquan'
  export default {
    name: 'serviceIntelligencePost',
    data () {
      return {
        active: 1,
        icon: {
          active: 'https://img01.yzcdn.cn/vant/user-active.png',
          inactive: 'https://img01.yzcdn.cn/vant/user-inactive.png'
        },
        showDialog: false,
        notices: [],
        queryParams: {
          current: 1,
          size: 10,
          companyName: ''
        },
        listData: [],
        companyMoldList: [],
        companyScaleList: [],
        companyTypeList: [],
        currentStudentData: {}
      }
    },
    created () {
      // Promise.all([
      //   this.getDictType('company_mold', 'companyMoldList'),
      //   this.getDictType('company_scale', 'companyScaleList'),
      //   this.getDictType('company_company_type', 'companyTypeList')
      // ]).then(res => {
      //   this.getData()
      // })

      if (!sessionStorage.getItem("service_phone")) {
        this.$router.replace({ path: '/servicePost' })
      }
    },
    components: {
      listPost
    },
    watch: {},
    methods: {
      
      getPostStatus (target, prop, row) {
        const item = this[target].find(item => item.value == row[prop])
  
        if (item) {
          return item.text
        } else {
          return '无'
        }
      },
      async postFullInfo() {
        const res = await postFullInfo({phone: sessionStorage.getItem("service_phone")})
        if (res.code == 200) {
          this.currentStudentData = res.data;
          this.showDialog = true;
        }
        console.log("res", res)
      },
      async getDictType (type, target, callback) {
        return new Promise(async (resolve, reject) => {
          const res = await getDictType(type)
          if (res.code == 200) {
            resolve()
            res.data.forEach(item => {
              this[target].push({
                text: item.dictLabel,
                value: item.dictValue
              })
            })
          } else {
            reject()
          }
        })
      },
      async handleConfirm() {
        Toast('请联系班主任更改信息')
        // const res = await postGetLinkCode();
        // if (res.code == 200) {
          // this.showDialog = false;
          // console.log(res, "resssssssssss")
          // window.location.href = 'https://zh.chengmingxt.com/?formId=1&page=2&code=' + res.data + '&projectId=1'
        // }
      },
      handleTips() {
        this.postFullInfo()
        // Toast('请联系班主任更改信息')
      },
      toUrl (path) {
        if (!path) {
          Toast('功能开发中')
          return
        }
  
        this.$router.replace({ path })
      }
    }
  }
  </script>
  <style scoped lang="scss">
  
  .van-tabbar {
    width: 100vw;
  }

  .box-wrapper {
    padding: 20px;
    ul {
      height: 300px;
      overflow-y: auto;
      li {
        display: flex;
        // justify-content: space-between;
        margin: 20px 0px;
        span {
          display: block;
          font-size: 14px;
        }

        span:first-child {
          color: #999;
        }

        span:last-child{
          // font-weight: bold;
        }
      }
    }
  }
  .text {
    width: 100%;
    background-color: white;
    font-size: 20px;
    // line-height: 40px;
    font-weight: bold;
    padding: 16px 10px;
    padding-top: 18px;
    margin-bottom: 30px;
    // padding-bottom: 200px;
  }
  .min_box {
    width: 100%;
    margin: 0 auto;
    padding: 0 5px;
    padding-top: 18px;
    background-color: white;
    .min_item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      justify-items: center;
    }
  }
  
  .icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    font-size: 40px;
  }
  
  .tool {
    width: 100%;
    height: 100vh;
    background: #f3f6f9;
  
    .content {
      width: 95%;
      height: 300px;
      border-radius: 10px;
      background: #fff;
      margin: 30px auto;
  
      ul {
        display: flex;
  
        li {
          width: 80px;
          height: 50px;
          // box-shadow: 0px 0px 0px 1px #ddd;
          text-align: center;
          // line-height: 50px;
          margin-right: 10px;
          margin-top: 50px;
        }
      }
    }
  }

  .title-block {
    height: 60px;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    background: #fff;
    z-index: 100;
    padding: 10px;
  }
  
  
  </style>
  